import gql from "graphql-tag";

export const UPLOAD_FILE_MUTATION = gql`
  mutation UploadFile($fileName: String!, $fileCategoryId: ID!, $file: Upload!, $companyId: ID!) {
    uploadFile(file: $file, fileName: $fileName, fileCategoryId: $fileCategoryId, companyId: $companyId)
  }
`;
